import Backbone from "backbone";
import TwoHoursDeliveryPromiseView from "./TwoHoursDeliveryPromiseView";
import {region, pathname} from "../../common/others/Configuration";
import $ from "jquery";
import _ from "underscore";
import SharedDispatcher from "../../common/others/SharedDispatcher";
import { MagnificPopup } from "../../common/dynamic-imports/MagnificPopup";

export default Backbone.View.extend({

      twoHoursDeliveryPromise: '2-hours-delivery-promise',

    events: {
        "click .js-ProductStimulusChrono-button": "openTwoHoursDeliveryPromisePopin"
    },

    initialize: function() {
      this.magnificPopup = new MagnificPopup();
    },

    openTwoHoursDeliveryPromisePopin: function (e) {
      e.preventDefault();
      if (region === "ES") {
          var link = $(".js-ProductStimulusChrono-button").prop("href");
        var defaultOptions = {
          items: { src: "<div class='container-iframe'><iframe src=" + link + " class='mfp-content--iframe' width='800' height='600px'  scrolling='no' frameborder='0' cellspadding='0' cellsmargin='0'></iframe><div class='close closeIframe'></div></div>" },
          type: 'inline'
        };
        this.magnificPopup.open(defaultOptions);
      } else {

        this.getPopinContent(this.twoHoursDeliveryPromise).done((function(res) {
          this.openPopin(res, {
            callbacks: {
              open: function() {
                new TwoHoursDeliveryPromiseView({ el: this.content });
              }
            }
          });
        }).bind(this));
      }
    },

    getPopinContent: function(popinPageName) {
      SharedDispatcher.trigger("overlay:show");
      var url = [pathname, '/popins/', popinPageName].join('');
      return $.ajax({
        url: url,
        type: 'GET',
        dataType: 'html',
        error: function() { SharedDispatcher.trigger("overlay:hide"); },
        success: function() { SharedDispatcher.trigger("overlay:hide"); }
      });
    },

    openPopin: function(data, opts) {
      var defaultOptions = {
        items: { src: data },
        type: 'inline'
      };
      _.extend(defaultOptions, opts);
      this.magnificPopup.open(defaultOptions);
    }

  });
